import { render, staticRenderFns } from "./BajaBien.vue?vue&type=template&id=0668bef4"
import script from "./BajaBien.vue?vue&type=script&lang=js"
export * from "./BajaBien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports